import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import Logger from './Logger';
import get from 'lodash/get';
var BugReporter = (function () {
    function BugReporter(apiKey, version, environment) {
        var _this = this;
        this.handleBeforeSend = function (report) {
            if (Logger.isEnabled())
                report.updateMetaData('LogRocket', { sessionURL: Logger.sessionUrl() });
            if (!Array.isArray(report.stacktrace) || report.stacktrace.length === 0) {
                var promiseRejectionReason = get(report, 'metaData.promise["rejection reason"]');
                if (promiseRejectionReason) {
                    var stringReason = JSON.stringify(promiseRejectionReason);
                    report.groupingHash = stringReason;
                    report.errorMessage = stringReason;
                }
                else
                    report.groupingHash = report.errorClass + report.errorMessage;
            }
            if (!_this.getState)
                return;
            var state = _this.getState();
            if ((JSON.stringify(report) + JSON.stringify(state)).length <= 900000) {
                report.updateMetaData('Client State', state);
            }
        };
        this.bugsnagClient = bugsnag({
            apiKey: apiKey,
            releaseStage: environment,
            notifyReleaseStages: ['production', 'staging'],
            appVersion: version,
            consoleBreadcrumbsEnabled: false,
            beforeSend: this.handleBeforeSend
        });
    }
    BugReporter.prototype.getReactErrorBoundary = function (react) {
        if (!this.reactErrorBoundary) {
            this.bugsnagClient.use(bugsnagReact, react);
            this.reactErrorBoundary = this.bugsnagClient.getPlugin('react');
        }
        return this.reactErrorBoundary;
    };
    BugReporter.prototype.notify = function (error) {
        this.bugsnagClient.notify(error);
    };
    return BugReporter;
}());
export default BugReporter;
//# sourceMappingURL=BugReporter.js.map